import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // ── Greeting / Home
    greet: 'Salam,',
    walletBalance: 'Wallet Balance',
    send: 'Send',
    receive: 'Receive',
    topUp: 'Top Up',
    payQR: 'Pay QR',
    scanQR: 'Scan QR',
    recent: 'Recent',
    seeAll: 'See all',
    thisMonth: 'This Month',
    thisMonthBadge: '+12.4% this month',
    hideBalance: 'Hide',
    showBalance: 'Show',

    // ── Bottom nav
    home: 'Home',
    wallet: 'Wallet',
    cards: 'Cards',
    scan: 'Scan',
    activity: 'Activity',
    profile: 'Profile',

    // ── Send Money
    sendMoney: 'Send Money',
    enterSimoId: 'Search by name or @SimoID',
    scanQRPay: 'Pay via QR instead',
    recentContacts: 'Recent',
    allContacts: 'All Contacts',
    simoId: 'SimoPay ID',
    amount: 'Amount (MAD)',
    enterAmount: 'Enter Amount',
    sendNow: 'Send Now',
    noContactsFound: 'No contacts found',
    sendingTo: 'Sending to',
    back: '←',

    // ── Top Up
    topUpTitle: 'Top Up',
    addFunds: 'Add Funds',
    chooseMethod: 'Choose Method',
    bankTransfer: 'Bank Transfer',
    debitCard: 'Debit / Credit Card',
    cashDeposit: 'Cash Deposit',
    continueBtn: 'Continue',
    instant: 'Instant',
    minutes: '~5 min',

    // ── QR Screen
    scanQRTitle: 'Scan QR Code',
    pointCamera: 'Point at payment code',
    simulateScan: 'Simulate',
    simulateScanFull: 'Simulate Scan (Demo)',
    readyToScan: 'Ready to scan',
    alignQR: 'Align the QR code within the frame',
    payManually: 'Pay Manually',
    enterSimoIdManual: 'Enter SimoPay ID',
    paying: 'Paying',

    // ── Activity
    allTx: 'All',
    sentTx: 'Sent',
    receivedTx: 'Received',
    activityTitle: 'Activity',
    allTransactionsSubtitle: 'All transactions',
    txCount: 'tx',

    // ── Transaction Categories
    catFood: 'Food',
    catShopping: 'Shopping',
    catTopUp: 'Top Up',
    catTransfer: 'Transfer',

    // ── Time labels
    justNow: 'Just now',
    yesterday: 'Yesterday',
    secondsAgo: 's ago',
    minutesAgo: 'm ago',
    hoursAgo: 'h ago',
    daysAgo: 'd ago',

    // ── Transaction names (seed)
    txCafeBoulevard: 'Café Boulevard',
    txTopUpCard: 'Top Up — Card',
    txMarjane: 'Marjane Supermarket',
    txTopUpBank: 'Top Up — Bank',
    txCafeAtlas: 'Café Atlas',
    txTopUpPrefix: 'Top Up — ',

    // ── My QR
    myQRTitle: 'My QR Code',
    shareDesc: 'Share this code to receive payments',
    walletId: 'SimoPay ID',
    copy: 'Copy',
    copied: '✓ Copied',
    share: 'Share ↗',
    saveQR: 'Save QR',

    // ── Wallet screen
    walletTitle: 'Wallet',
    manageFunds: 'Manage your funds',

    // ── Cards (SIMO Card)
    cardsTitle: 'Cards',
    chooseCardTitle: 'Choose card',
    virtualCardTab: 'Virtual card',
    physicalCardTab: 'Physical card',
    standardCard: 'Standard card',
    virtualCardBlurb: 'Works with Apple & Google Pay. Accepted by millions of merchants worldwide.',
    physicalCardBlurb: 'No annual fees or hidden costs. Global ATM access.',
    applyForCard: 'Apply for card',
    applyFeeVirtual: '49 MAD',
    applyFeePhysical: '399 MAD',
    cardApplicationSent: 'Card added successfully.',
    cardsTxTitle: 'Transactions',
    cardEndingIn: 'Ending',
    txDeclined: 'Declined',
    cardsActionView: 'View',
    cardsActionFreeze: 'Freeze',
    cardsActionLimit: 'Limit',
    cardsActionSettings: 'Settings',
    addedToWallet: 'Added to Apple Wallet',
    addAnotherCard: 'Apply for another card',
    cardsGetStarted: 'Get your SIMO PAY card',
    cardsSeeActivity: 'Open Activity',
    cardsWalletReady: 'Ready for Apple & Google Pay',
    cardsKindVirtual: 'Virtual',
    cardsKindPhysical: 'Physical',
    cardsPanReady: 'Ready',
    cardsPanPreview: 'Preview',
    madBalance: 'MAD Balance',
    savings: 'Savings',
    spending: 'Spending',

    // ── Receive
    receiveTitle: 'Receive Money',
    receiveDesc: "Choose how you'd like to receive",
    showMyQR: 'Show My QR Code',
    showMyQRDesc: 'Let sender scan your personal code',
    copyLink: 'Copy Wallet Link',
    copyLinkDesc: 'Share your payment link',

    // ── Profile
    profileTitle: 'Profile',
    verified: '✓ Verified',
    sectionAccount: 'Account',
    sectionSecurity: 'Security',
    sectionPreferences: 'Preferences',
    sectionSupport: 'Support',
    personalInfo: 'Personal Information',
    personalInfoDesc: 'Name, email, phone',
    simoIdLabel: 'SimoPay ID',
    kycVerification: 'KYC Verification',
    kycVerified: 'Verified',
    changePassword: 'Change Password',
    biometricLock: 'Biometric Lock',
    transactionPIN: 'Transaction PIN',
    languageLabel: 'Language',
    languageEnglish: 'English',
    languageArabic: 'العربية',
    defaultCurrency: 'Default Currency',
    notifications: 'Notifications',
    helpCenter: 'Help Center',
    contactSupport: 'Contact Support',
    termsPrivacy: 'Terms & Privacy',
    logout: 'Log Out',
    appVersion: 'SIMO Pay v1.0.0',
    moroccoMade: 'Made in Morocco 🇲🇦',

    // ── PIN Screen
    confirmPayment: 'Confirm Payment',
    confirmTopUp: 'Confirm Top-Up',
    confirmTransfer: 'Confirm Transfer',
    enterPIN: 'Enter your 6-digit PIN',
    demoPIN: 'Demo PIN:',
    incorrectPIN: 'Incorrect PIN. Please try again.',
    verifying: 'Verifying…',
    pinAmountLabel: 'Amount',
    pinMethodLabel: 'Method',
    pinToLabel: 'To',

    // ── Toasts
    toastTopUpSuccess: (amt, method) => `Top up of ${amt} MAD via ${method} successful!`,
    toastSendSuccess: (amt, simoId) => `Sent ${amt} MAD to ${simoId}`,
    toastQRSuccess: (amt) => `QR scanned! Café Atlas — ${amt} MAD payment confirmed.`,
    toastPaySuccess: (amt, target) => `Paid ${amt} MAD to ${target}`,

    // ── Dashboard header
    backToSimo: '← Back to SIMO',
    liveDemo: 'Live Demo',
    interactiveDemo: 'Interactive demo · No signup required',
  },

  ar: {
    // ── Darija (Moroccan Arabic) — most widely spoken in Morocco
    greet: 'السلام،',
    walletBalance: 'الرصيد',
    send: 'صيفط',
    receive: 'استقبل',
    topUp: 'شحن',
    payQR: 'خلص QR',
    scanQR: 'امسح',
    recent: 'الأخيرة',
    seeAll: 'شوف الكل',
    thisMonth: 'هاد الشهر',
    thisMonthBadge: '+12.4% هاد الشهر',
    hideBalance: 'خبّي',
    showBalance: 'بيّن',

    home: 'الرئيسية',
    wallet: 'المحفظة',
    cards: 'البطاقات',
    scan: 'امسح',
    activity: 'السجل',
    profile: 'الحساب',

    sendMoney: 'صيفط الفلوس',
    enterSimoId: 'قلب بالاسم أو @SimoID',
    scanQRPay: 'خلص بـ QR عوض',
    recentContacts: 'الأخيرة',
    allContacts: 'كاع الجهات',
    simoId: 'رقم SimoPay',
    amount: 'المبلغ (درهم)',
    enterAmount: 'دخل المبلغ',
    sendNow: 'صيفط دابا',
    noContactsFound: 'ما لقينا حتى جهة',
    sendingTo: 'كنصيفط لـ',
    back: '←',

    topUpTitle: 'شحن',
    addFunds: 'زيد فلوس',
    chooseMethod: 'اختار الطريقة',
    bankTransfer: 'تحويل بنكي',
    debitCard: 'الكارط',
    cashDeposit: 'إيداع كاش',
    continueBtn: 'كمل',
    instant: 'دغيا',
    minutes: '~5 دقائق',

    scanQRTitle: 'مسح رمز QR',
    pointCamera: 'صوّب على رمز الخلاص',
    simulateScan: 'محاكاة',
    simulateScanFull: 'محاكاة المسح (تجريبي)',
    readyToScan: 'جاهز للمسح',
    alignQR: 'حط رمز QR داخل الإطار',
    payManually: 'خلص يدويا',
    enterSimoIdManual: 'دخل رقم SimoPay',
    paying: 'كنخلص',

    allTx: 'الكل',
    sentTx: 'مصيفطة',
    receivedTx: 'مستقبلة',
    activityTitle: 'السجل',
    allTransactionsSubtitle: 'كاع المعاملات',
    txCount: 'معاملة',

    catFood: 'ماكلة',
    catShopping: 'تسوق',
    catTopUp: 'شحن',
    catTransfer: 'تحويل',

    justNow: 'دابا',
    yesterday: 'البارح',
    secondsAgo: ' ثا',
    minutesAgo: ' د',
    hoursAgo: ' س',
    daysAgo: ' يوم',

    txCafeBoulevard: 'قهوة بولفار',
    txTopUpCard: 'شحن — كارط',
    txMarjane: 'مرجان',
    txTopUpBank: 'شحن — بنك',
    txCafeAtlas: 'قهوة أطلس',
    txTopUpPrefix: 'شحن — ',

    myQRTitle: 'رمز QR ديالي',
    shareDesc: 'شارك هاد الرمز باش تستقبل فلوس',
    walletId: 'رقم SimoPay',
    copy: 'نسخ',
    copied: '✓ تم',
    share: 'شارك ↗',
    saveQR: 'احفظ',

    walletTitle: 'المحفظة',
    manageFunds: 'دير فلوسك',

    cardsTitle: 'البطاقات',
    chooseCardTitle: 'اختار البطاقة',
    virtualCardTab: 'بطاقة افتراضية',
    physicalCardTab: 'بطاقة فيزيائية',
    standardCard: 'البطاقة الأساسية',
    virtualCardBlurb: 'خدم Apple Pay و Google Pay. مقبولة عند ملايين المتاجر.',
    physicalCardBlurb: 'بلا رسوم سنوية. سحب من أجهزة الصراف عالمياً.',
    applyForCard: 'طلب البطاقة',
    applyFeeVirtual: '49 درهم',
    applyFeePhysical: '399 درهم',
    cardApplicationSent: 'تمت إضافة البطاقة بنجاح.',
    cardsTxTitle: 'العمليات',
    cardEndingIn: 'تنتهي بـ',
    txDeclined: 'مرفوض',
    cardsActionView: 'عرض',
    cardsActionFreeze: 'تجميد',
    cardsActionLimit: 'الحد',
    cardsActionSettings: 'الإعدادات',
    addedToWallet: 'مضافة لـ Apple Wallet',
    addAnotherCard: 'طلب بطاقة أخرى',
    cardsGetStarted: 'بطاقة SIMO PAY ديالك',
    cardsSeeActivity: 'فتح السجل',
    cardsWalletReady: 'جاهزة لـ Apple و Google Pay',
    cardsKindVirtual: 'افتراضية',
    cardsKindPhysical: 'فيزيائية',
    cardsPanReady: 'جاهزة',
    cardsPanPreview: 'معاينة',
    madBalance: 'رصيد بالدرهم',
    savings: 'الادخار',
    spending: 'المصاريف',

    receiveTitle: 'استقبل فلوس',
    receiveDesc: 'اختار كيفاش تستقبل',
    showMyQR: 'بيّن رمز QR ديالي',
    showMyQRDesc: 'خلي اللي كيخلص يمسح الرمز ديالك',
    copyLink: 'نسخ رابط المحفظة',
    copyLinkDesc: 'شارك رابط الخلاص',

    profileTitle: 'الحساب',
    verified: '✓ موثّق',
    sectionAccount: 'الحساب',
    sectionSecurity: 'الأمان',
    sectionPreferences: 'التفضيلات',
    sectionSupport: 'الدعم',
    personalInfo: 'المعلومات الشخصية',
    personalInfoDesc: 'الاسم، الإيميل، التيليفون',
    simoIdLabel: 'رقم SimoPay',
    kycVerification: 'التحقق KYC',
    kycVerified: 'موثّق',
    changePassword: 'بدّل الباسوور',
    biometricLock: 'القفل البيومتري',
    transactionPIN: 'كود المعاملات',
    languageLabel: 'اللغة',
    languageEnglish: 'English',
    languageArabic: 'العربية',
    defaultCurrency: 'العملة الافتراضية',
    notifications: 'الإشعارات',
    helpCenter: 'مركز المساعدة',
    contactSupport: 'تواصل مع الدعم',
    termsPrivacy: 'الشروط والخصوصية',
    logout: 'خروج',
    appVersion: 'SIMO Pay v1.0.0',
    moroccoMade: 'مصنوع فالمغرب 🇲🇦',

    confirmPayment: 'تأكيد الخلاص',
    confirmTopUp: 'تأكيد الشحن',
    confirmTransfer: 'تأكيد التحويل',
    enterPIN: 'دخل الكود ديالك (6 أرقام)',
    demoPIN: 'الكود التجريبي:',
    incorrectPIN: 'الكود غالط. عاود حاول.',
    verifying: 'كنتأكد…',
    pinAmountLabel: 'المبلغ',
    pinMethodLabel: 'الطريقة',
    pinToLabel: 'لـ',

    toastTopUpSuccess: (amt, method) => `الشحن ديال ${amt} درهم بـ${method} تم بنجاح!`,
    toastSendSuccess: (amt, simoId) => `صيفطنا ${amt} درهم لـ ${simoId}`,
    toastQRSuccess: (amt) => `تمسح! قهوة أطلس — تأكد الخلاص ديال ${amt} درهم.`,
    toastPaySuccess: (amt, target) => `خلصنا ${amt} درهم لـ ${target}`,

    backToSimo: '→ رجوع لـ SIMO',
    liveDemo: 'تجريبي مباشر',
    interactiveDemo: 'تجربة تفاعلية · بلا تسجيل',
  },
};

const LanguageContext = createContext({
  lang: 'en',
  t: translations.en,
  setLang: () => {},
  isRTL: false,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const t = translations[lang];
  // Layout stays LTR; only text content changes when switching to Arabic
  const isRTL = false;

  return (
    <LanguageContext.Provider value={{ lang, t, setLang, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;
